export default __webpack_public_path__ + "static/media/Minimize.572db86c.svg";